<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="top-bar custom-topbar">
  <app-metric-display [same]="same" [checkstartDate]="checkStartDate" [checkendDate]="checkEndDate"
    [parkingLotByStates]="parkingLotByStates" [parkerCount]="parkerCount" [groupBookingCount]="groupBookingCount" [selectedParkingLot]="selectedParkingLot" [start]="start" [end]="end"
    (parkingLotByStatesOnChange)="onOptionSelected($event)" (dateRangeData)="dateRangeDataFuc($event)" (searchChanges)="search($event,'onSerchClick')">
  </app-metric-display>
</div>

<div class="dashboard-bg">
  <app-revenue-display [totalRevenue]="totalRevenue" [occupiedCount]="occupiedCount" [vacantCount]="vacantCount" [revenueWithTransactionFees]="revenueWithTransactionFees" [revenueWithTaxAndFees]="revenueWithTaxAndFees" [maintenanceCount]="maintenanceCount" [dateRangeData]="dateRangeData" [parkerCount]="parkerCount" [groupBookingCount]="groupBookingCount" [groupBookingSlotCounts]="groupBookingSlotCounts" [oneTimeBookingCount]="oneTimeBookingCount" [parkingStatsOptions]="parkingStatsOptions" [parkingStatsData]="parkingStatsData" [totalBookings]="totalBookings" [peakHoursStartTime]="peakHoursStartTime" [peakHoursEndTime]="peakHoursEndTime" [selectedParkingLot]="selectedParkingLot" [checkStartDate]="checkStartDate" [checkEndDate]="checkEndDate" [companyId]="id" [role]="role"></app-revenue-display>

  <div class="grid custom-grids monthy-revenue">
    <div class="col-12 md:col-6 lg:col-6 custom-spacing-right">
      <div class="revenue-outer">

        <div class="vparking-outer custom-monthly">
          <div class="top-heading">
            <h4>Monthly Revenue </h4>
            <p class="calendar-icon"><img src="assets/images/calendar-new.svg" alt="calender" /><span>{{checkStartDate }} to
                {{checkEndDate}}</span></p>
          </div>
        </div>
        <app-revenue-chart [revenueData]="revenueData"
          [chartOptionsForGraph]="chartOptionsForGraph"></app-revenue-chart>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-6 custom-spacing-lright  right-padding">
      <div class="revenue-outer">
        <div class="vparking-outer custom-monthly">
          <div class="top-heading calculate-outer">
            <h4>Occupancy %</h4>
            <p class="calendar-icon"><img src="assets/images/calendar-new.svg" alt="calender"/><span>{{checkStartDate }} to
                {{checkEndDate}}</span></p>
          </div>
        </div>
        <app-occupancy-chart [parkingLotsData]="parkingLotsData" [chartOptions]="chartOptions" [year]="year"
          [selectedYear]="selectedYear"></app-occupancy-chart>
      </div>
    </div>
  </div>
  <app-revenue-dashboard [selectedCompany]="id" [dateValidationError]="dateValidationError" [checkStartDate]="checkStartDate" [checkEndDate]="checkEndDate" [selectedParkingLot]="selectedParkingLot" [searchClick]="searchclick"></app-revenue-dashboard>
</div>
